import type { UUID } from "../../utils/uuid";

export interface CustomDashboardConfig {
  id: UUID;
  enabled: boolean;
  url: string;
  tabName: string;
}

export interface EditableCustomDashboardConfig {
  id: UUID | null;
  enabled: boolean;
  url: string;
  tabName: string;
}

export interface StoredCustomDashboardConfig {
  id: UUID;
  enabled: boolean;
  url: string;
  tab_name: string;
}

export const toCustomDashboardConfig = ({
  id,
  enabled,
  url,
  tab_name,
}: StoredCustomDashboardConfig): CustomDashboardConfig => ({
  id,
  enabled,
  url: url.trim(),
  tabName: tab_name.trim(),
});

export const isValidDashboardUrl = (value: string): boolean => {
  try {
    const url = new URL(value);
    return (
      url.protocol === "https:" &&
      (url.hostname === "luzmo.com" || url.hostname.endsWith(".luzmo.com"))
    );
  } catch {
    return false;
  }
};

export const visibleCustomDashboardConfigs = (
  dashboards: StoredCustomDashboardConfig[],
): CustomDashboardConfig[] =>
  dashboards.flatMap((dashboard) => {
    const config = toCustomDashboardConfig(dashboard);
    return config.enabled && config.tabName && isValidDashboardUrl(config.url) ? [config] : [];
  });
